import {Component, OnInit} from '@angular/core';
import {GameInstanceService} from "../../services/game-instance.service";
import {GameService} from "../../services/game.service";
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {IActiveGameInstance} from "../../interfaces/IActiveGameInstance";
import {PermissionTypes} from "../../enum/PermissionTypes";
import {EndGameInstanceComponent} from "../../components/dialogs/end-game-instance/end-game-instance.component";
import {MatDialog} from "@angular/material/dialog";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatMiniFabButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {
  DisplayActiveGameInstanceComponent
} from "../../components/display-active-game-instance/display-active-game-instance.component";
import {MatIcon} from "@angular/material/icon";
import {
  UserHasCausableAdminAccessDirective
} from "../../directives/permissions/user-has-causable-admin-access.directive";
import {EmailBlastComponent} from "../../components/dialogs/email-blast/email-blast.component";
import {HasPermissionDirective} from "../../directives/permissions/has-permission";
import {ContainerComponent} from "@coreui/angular";
import {ActiveUserService} from "../../services/active-user.service";
import {SnackbarService} from "../../services/snackbar.service";
import {GameInstanceStatuses} from "../../enum/GameInstanceStatusEnum";

@Component({
  selector: 'app-active-game-instances',
  standalone: true,
  templateUrl: './active-game-instances.component.html',
  imports: [
    MatMenu,
    MatIcon,
    MatMenuItem,
    MatMiniFabButton,
    MatMenuTrigger,
    MatTooltip,
    DisplayActiveGameInstanceComponent,
    UserHasCausableAdminAccessDirective,
    HasPermissionDirective,
    ContainerComponent
  ],
  styleUrls: ['./active-game-instances.component.scss']
})
export class ActiveGameInstancesComponent implements OnInit {
  public activeGame: IGameQueryResult | undefined = this.gameService.activeGame();
  public chosenGamesActiveDraw: IActiveGameInstance | null = null;
  protected readonly PermissionTypes = PermissionTypes;

  constructor(private gameInstanceService: GameInstanceService,
              private matDialog: MatDialog,
              private snackBarService: SnackbarService,
              private activeUserService: ActiveUserService,
              private gameService: GameService) {
  }

  protected readonly permissionTypes = PermissionTypes;
  protected readonly GameInstanceStatuses = GameInstanceStatuses;

  ngOnInit(): void {
    this.gameInstanceService.activeGameInstanceByGame(this.activeGame?.Id!, this.activeUserService.activeUser().Id).subscribe({
      next: (activeGameInstanceP: IActiveGameInstance) => {
        this.chosenGamesActiveDraw = activeGameInstanceP;
      },
      error: (err) => {
        if (err?.Error?.status === 404) {
          this.chosenGamesActiveDraw = null;
          this.snackBarService.openErrorSnackBar('Looks like there is no active game instance for this game');
        } else {
          this.snackBarService.openErrorSnackBar('There was an error retrieving the active game instance for this game. Please try again or contact a system admin');
        }
      }
    })
  }

  openEndGameInstance() {
    this.matDialog.open(EndGameInstanceComponent, {
      data: this.gameInstanceService.activeGameInstance(),
      disableClose: true
    })
  }

  openEmailBlast() {
    this.matDialog.open(EmailBlastComponent)
  }
}
